import { useMemo } from 'react';
import useAdTopData from '@/hooks/useAdTopData';
import useIsMobileDevice from '@/hooks/useIsMobileDevice';
import { useShallShowAds } from '@/hooks/useShallShowAds';
import styles from './index.module.scss';

export default function AdTop () {
  const { isMobile } = useIsMobileDevice();
  const { adTopImpression, adTopPicture, adTopURL, shallShowAdTop } = useAdTopData({ isMobile });
  const { shallShowAds } = useShallShowAds();
  const shallRenderAdTopImpression = useMemo(() => Boolean(adTopImpression), [adTopImpression]);

  if (!shallShowAdTop || !shallShowAds) {
    return null;
  }

  return (
    <div className={styles['ad-top']} data-bd-viewability='1' data-bd-viewability-id='rtcbar'>
      <span className={styles['ad-top__label']}>REKLAMA</span>
      <a className={styles['ad-top__wrapper']} href={adTopURL} rel='sponsored noreferrer' target='_blank'>
        <img className={styles['ad-top__image']} src={adTopPicture} />
      </a>
      {shallRenderAdTopImpression ? <img alt='Advertisement' className={styles['ad-top__impression']} height='1' src={adTopImpression} width='1' /> : null}
    </div>
  );
}
